import { WebTracerProvider } from "@opentelemetry/sdk-trace-web";
import { registerInstrumentations } from "@opentelemetry/instrumentation";
import { ZoneContextManager } from "@opentelemetry/context-zone";
import { defaultResource, resourceFromAttributes } from "@opentelemetry/resources";
import { ATTR_SERVICE_NAME } from "@opentelemetry/semantic-conventions";
import { BatchSpanProcessor } from "@opentelemetry/sdk-trace-base";
import { OTLPTraceExporter } from "@opentelemetry/exporter-trace-otlp-http";

import { DocumentLoadInstrumentation } from "@opentelemetry/instrumentation-document-load";
import { FetchInstrumentation } from "@opentelemetry/instrumentation-fetch";
import { UserInteractionInstrumentation } from "@opentelemetry/instrumentation-user-interaction";
import { isProd } from "components/util/isProd";

export function initTelemetry() {
    const exporter = new OTLPTraceExporter({
        url: "https://ingress.eu-west-1.aws.dash0.com/v1/traces",
        headers: {
            Authorization: "Bearer auth_bkRPsAmT61l7eMBsBgsIjyQ0NH7EwFdb",
        },
    });

    const provider = new WebTracerProvider({
        spanProcessors: [new BatchSpanProcessor(exporter)],
        resource: defaultResource().merge(resourceFromAttributes({
            application: "liveheats",
            [ATTR_SERVICE_NAME]: "liveheats-web",
            ["deployment.environment.name"]: isProd() ? "production" : "staging",
        })),
    });

    provider.register({ contextManager: new ZoneContextManager() });

    registerInstrumentations({
        instrumentations: [
            new DocumentLoadInstrumentation(),
            new FetchInstrumentation(),
            new UserInteractionInstrumentation(),
        ],
    });

    return provider;
}
